import { render, staticRenderFns } from "./ReactMountTransportadora.vue?vue&type=template&id=7ecf5a51"
import script from "./ReactMountTransportadora.vue?vue&type=script&lang=ts"
export * from "./ReactMountTransportadora.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ecf5a51')) {
      api.createRecord('7ecf5a51', component.options)
    } else {
      api.reload('7ecf5a51', component.options)
    }
    module.hot.accept("./ReactMountTransportadora.vue?vue&type=template&id=7ecf5a51", function () {
      api.rerender('7ecf5a51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountTransportadora.vue"
export default component.exports